function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

/*jshint esversion: 6 */
export var PledgeUtils = /*#__PURE__*/function () {
  function PledgeUtils() {
    _classCallCheck(this, PledgeUtils);
  }

  _createClass(PledgeUtils, null, [{
    key: "mapPledgeStatusToAppLabel",
    value: function mapPledgeStatusToAppLabel(pledgeStatus, i18n) {
      if (!!pledgeStatus) {
        var pledgeStatusLabel = {
          "Active": i18n.activePledgeStatusLabel,
          "Completed": i18n.completedPledgeStatusLabel,
          "Discontinued": i18n.discontinuedPledgeStatusLabel,
          "Pending": i18n.pendingPledgeStatusLabel
        };
        return pledgeStatusLabel[pledgeStatus];
      }

      return "";
    }
  }]);

  return PledgeUtils;
}();